import { Inject, Injectable } from '@angular/core';

import { EnvironmentSettings } from 'models/environment-settings.model';

@Injectable({ providedIn: 'root' })
export class EnvironmentSettingsService {
  private settingsConfig!: EnvironmentSettings;

  get settings(): EnvironmentSettings {
    return this.settingsConfig;
  }

  constructor(@Inject('envSettings') private envSettings: EnvironmentSettings) {
    this.settingsConfig = this.envSettings;
  }
}
